const state = {
  surveys: [],
  survey: undefined,
  loaded: false
};

export default state;
